// Định dạng dùng chung cho giao diện mới.

/** 499000 → "499.000₫" */
export const formatVnd = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";
  return `${n.toLocaleString("vi-VN")}₫`;
};

/** 1234 → "1,2k" (kiểu Việt: dấu phẩy thập phân) */
export const formatCompact = (value) => {
  const n = Number(value) || 0;
  if (n >= 1000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "").replace(".", ",")}k`;
  return String(n);
};

/**
 * Hạ <h1> trong HTML do admin soạn (mô tả SP, bài viết) xuống <h2>: trang chỉ được có 1 H1
 * là tên sản phẩm/bài. 10 mô tả SP từng có 5–7 thẻ H1 → Google thấy 7 H1/trang.
 * Mirror của demoteH1 trong healthymall-be ogController — giữ đồng bộ.
 */
export const demoteH1 = (html) => String(html || "").replace(/<(\/?)h1(?=[\s>])/gi, "<$1h2");

/** % giảm thực tế giữa giá gốc và giá đang bán (0 nếu không giảm). */
export const discountPercent = (original, current) => {
  const o = Number(original);
  const c = Number(current);
  if (!o || !c || c >= o) return 0;
  return Math.round((1 - c / o) * 100);
};

/** Tên ngắn cho câu ưu đãi/quà tặng: bỏ phần mô tả sau " | " hoặc " - "
 *  ("Viên Uống PERDAYS Pregnancy Iron & Vitamin C | Hỗ Trợ…" → "Viên Uống PERDAYS Pregnancy Iron & Vitamin C"). */
export const shortName = (name) => String(name || "").split(" | ")[0].split(" - ")[0].trim();
